import {
  IPromoNewbuildingClickInfo,
  IPromoNewbuildingVisibleChangeInfo,
  NewbuildingPromoCarousel,
} from '@cian/frontend-newbuilding-promo-carousel-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { NEWBUILDING_SLIDES_COUNT } from '../../../constants/newbuildingsFromDeveloper';
import { selectOfferId } from '../../../selectors';
import { selectNewbuildingFromDeveloperIds } from '../../../selectors/newObject';
import { getNewbuildingsForPromoSlider } from '../../../services/newbuildingsForPromoSlider';
import { useApplicationContext } from '../../ApplicationContext';
import { trackNewbuildingCarouselChange, trackNewbuildingCardClick } from '../tracking';

export const NewbuildingPromoCarouselContainer: React.FC = () => {
  const lastPositionRef = React.useRef(0);
  const newbuildingIds = useSelector(selectNewbuildingFromDeveloperIds);
  const offerId = useSelector(selectOfferId);
  const context = useApplicationContext();

  const fetchNewbuildings = React.useCallback(
    async (newbuildingIds: number[]) => {
      const { newbuildings } = await getNewbuildingsForPromoSlider(context, { newbuildingIds });

      return newbuildings;
    },
    [context],
  );

  const handleNewbuildingChange = React.useCallback(
    (params: IPromoNewbuildingVisibleChangeInfo) => {
      if (params.position > lastPositionRef.current) {
        lastPositionRef.current = params.position;
        trackNewbuildingCarouselChange({ offerId, ...params });
      }
    },
    [offerId],
  );

  const handleNewbuildingClick = React.useCallback(
    (params: IPromoNewbuildingClickInfo) => {
      trackNewbuildingCardClick({ offerId, ...params });
    },
    [offerId],
  );

  return (
    <NewbuildingPromoCarousel
      ids={newbuildingIds}
      slidesPerView={NEWBUILDING_SLIDES_COUNT}
      fetchStep={NEWBUILDING_SLIDES_COUNT}
      fetchData={fetchNewbuildings}
      onNewbuildingChange={handleNewbuildingChange}
      onNewbuildingClick={handleNewbuildingClick}
    />
  );
};
